import React from 'react';
import Section from './Section';
import MetaTags from '../../../helpers/Common/MetaTags';
import { getMetaConfig } from '../../../helpers/Common/metaConfig';
import PrivacyAndPolicyPage from '../../Company/PrivacyAndPolicy/PrivacyAndPolicyPage';

const PrivacyAndPolicy = () => {
    const privacyMeta = getMetaConfig('privacyPolicy');
    
    return (
        <React.Fragment>
            <MetaTags {...privacyMeta} />
            <Section/>
            <PrivacyAndPolicyPage/>
        </React.Fragment>
    )
}
export default PrivacyAndPolicy;
